import React, { useState } from 'react';
import CookingStationCard from './CookingStationCard';
import { allBiomes } from '../../helperFunctions/getBiome';
import BiomeFilter from '../BiomeFilter/BiomeFilter';
import { allCookingStations } from '../../helperFunctions/getCookingStation';
import './CookingStations.css';

const CookingStations: React.FC = () => {
  const [selectedBiomes, setSelectedBiomes] = useState<string[]>(() => {
    const savedFilter = localStorage.getItem('biomeFilter');
    return savedFilter ? JSON.parse(savedFilter) : allBiomes;
  });

  const handleBiomesChange = (updatedBiomes: string[]) => {
    setSelectedBiomes(updatedBiomes);
  };

  return (
    <div className="cooking-stations-page">
      {/* Header Section */}
      <div className="cooking-stations-header">
        <h1 className="cooking-stations-title">Cooking Stations</h1>
        <p className="cooking-stations-subtitle">
          Explore all cooking stations in Valheim and discover the foods you can craft at each one. 
          Filter by biome to see only the foods available in your current progression.
        </p>
      </div>

      {/* Biome Filter Section */}
      <div className="cooking-stations-filter-container">
        <span className="filter-label">Filter by Biome:</span>
        <BiomeFilter onBiomesChange={handleBiomesChange} />
      </div>

      {/* Cooking Stations Grid */}
      <div className="cooking-stations-grid">
        {allCookingStations.map(station => (
          <CookingStationCard 
            key={station} 
            stationName={station} 
            selectedBiomes={selectedBiomes} 
          />
        ))}
      </div>
    </div>
  );
};

export default CookingStations;
